import styles from './classificationLoadingSkeleton.module.scss';

export const ClassificationLoadingSkeleton = () => (
  <div
    className={styles.classificationLoadingSkeleton}
    data-testid='classification-loading-skeleton'
    aria-busy='true'
    aria-label='Loading project classification'
  >
    <table>
      <tbody>
        {Array.from({ length: 3 }, (_, rowIndex) => (
          <tr key={rowIndex} data-testid='classification-row-skeleton'>
            {Array.from({ length: 5 }, (_, fieldIndex) => (
              <td key={fieldIndex} data-testid='classification-field-skeleton' aria-hidden='true'>
                <span className={styles.label} />
                <span className={styles.value} />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
